module.exports = "../dist/frontend/icons/ui/categoryPhone.svg?fe059b7720fac3f9e8fe6794fac32434";